const configuration = {
  $copyrights: [
    { name: '外语教学与研究出版社', link: 'http://www.fltrp.com/' },
    { name: '外研在线', link: 'https://www.unipus.cn/' }
  ],
  $icps: [
    '京ICP备11010362号-15',
    '京ICP证110931号',
    '京公网安备 11010802020459号'
  ]
}

export default configuration
